export const colorVariables = {
  blue_smalt: '#2288FF',
  blue_navyblue: '#0055FF',
  blue_ribbon: '#006EFF',
  blue_doger: '#2A8DFF',
  gray: '#A6A6A6',
  gray_cod: '#1A1A1A',
  gray_nightrider: '#333333',
  gray_darkgray: '#808080',
  gray_mediumlight: '#999999',
  gray_lightgray: '#CCCCCC',
  gray_smokegray: 'rgba(255, 255, 255, .5)',
  gray_lightsmoke: 'rgba(255, 255, 255, .35)',
  gray_verylightgray: '#D1D1D1',
  gray_zircon: '#E6E7E8',
  black: 'black',
  white: 'white',
  white_gainsboro: '#D8D8D8',
  white_lightgainsboro: '#D9D9D9',
  white_verylightgainsboro: '#DEDEDE',
  white_smoke: '#F2F2F2',
  green_light: '#22BB55',
  red: '#FF3333',
  red_bright: '#FF1111',
  yellow_dark: '#FF9900',
  turquoise: '#00C3C3',
  green_turquoise: '#23C3B2',
  orange: '#FF6600',
  error: 'linear-gradient(0deg, #FF3333 0%, #FF1111 100%)',
  success: 'linear-gradient(0deg, #33CC66 0%, #22BB55 100%)',
  none: 'none',

  // Embed
  main_color_embed: '#006EFF',
  main_hover_color_embed: '#0055FF',
  main_active_color_embed: '#0055FF',
  main_bg_color_embed: '#2288FF',
  main_default_color_embed: 'white',

  // CMS
  main_color_cms: 'rgb(255, 119, 34)',
  main_hover_color_cms: '#FF3300',
  main_active_color_cms: '#FF6600',
  main_default_color_cms: 'white',
};

export const fontVariables = {
  fs_xxxs: '10px',
  fs_xxs_: '11px',
  fs_xxs: '12px',
  fs_xs: '13px',
  fs_s: '14px',
  fs_md: '16px',
  fs_l: '18px',
  fs_xl: '20px',
  fs_xxl: '24px',
  fs_xxxl: '28px',
};

export const buttonSizeVariables = {
  s: '105px',
  m: '160px',
  l: '180px',
  xl: '240px',
  xxl: '345px',
};

export const socialsColor = {
  fb: '#3A5998',
  twitter: '#000000',
};

export const socialsHoverColor = {
  fb: '#486DB6',
  twitter: '#000000',
};

export const socialsActiveColor = {
  fb: '#293D79',
  twitter: '#000000',
};

export const mediaTemplates = {
  xxxs: '@media screen and (max-width: 420px)',
  xxs: '@media screen and (max-width: 469px)',
  xs: '@media screen and (max-width: 539px)',
  m: '@media screen and (min-width: 730px) and (min-height: 400px)',
  l: '@media screen and (min-width: 820px) and (min-height: 520px)',
  xl: '@media screen and (min-width: 1200px)',
  xxl: '@media screen and (min-width: 1440px)',
  mWidth: '@media screen and (min-width: 730px)',
  lWidth: '@media screen and (min-width: 820px)',
};

export const otherVariables = {
  trackHeight: '4px',
  trackMobileHeight: '3px',
};
